import tireHotelSvg from '../assets/tire-hotel.svg';

export const TireHotelSvg = () => <img src={tireHotelSvg} width={80} height={65} alt='' />;
